import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const pickupDateMachine =
  createTripArrayFieldMachine('pickupDate');
